import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { getListService } from '../../redux/actions/serviceBiller';
import { getBiller, billerCreate } from '../../redux/actions/billers';
import { getListBank } from '../../redux/actions/banks';
import { getListTnc } from '../../redux/actions/tnc';
import { getListForm } from '../../redux/actions/forms';
import BillerCreate from './BillerCreate.page';
import { getListPaymentMethod } from '../../redux/actions/paymentMethods';

const mapStateToProps = state => ({
  listTnc: state.allbiller.tncList,
  listBiller: state.billers,
  listService: state.allbiller.listService,
  listForm: state.allbiller.listForm,
  biller: state.allbiller.biller,
  listBank: state.allbiller.listBank,
  listPaymentMethod: state.allbiller.listPaymentMethod,
  loading: state.allbiller.loading,
});

const mapDispatchToProps = {
  getListService,
  getListForm,
  getListTnc,
  getBiller,
  billerCreate,
  getListBank,
  getListPaymentMethod,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(BillerCreate));
